// 9fbef606107a605d69c0edbcd8029e5d 
import { OVERLAY_MODAL_ACTION_PATTERN } from '@tcp/core/src/constants/reducer.constants';

export default {
  OPEN_OVERLAY: `${OVERLAY_MODAL_ACTION_PATTERN}OPEN_OVERLAY`,
  CLOSE_OVERLAY: `${OVERLAY_MODAL_ACTION_PATTERN}CLOSE_OVERLAY`,
};
